/*
 * COPYRIGHT Motorola Solutions, INC.
 * ALL RIGHTS RESERVED.
 * MOTOROLA SOLUTIONS CONFIDENTIAL RESTRICTED
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { MessageService } from './message.service';
import { Message } from 'CalltakingCoreApi';
import { deleteDtmfMessage, fetchPredefinedDtmfMessages, initializeDtmfMessageState, newDtmfMessage, updateDtmfMessage } from '../+state/message.actions';
import { PreDefinedMessage } from '../model/pre-defined-messages';
import { ClusterUrlProviderService } from '../../core/services/cluster-url-provider.service';
import { StompManagerService } from '../../core/services/stomp-manager/stomp-manager.service';
import { Topic } from '../../user/model/multiple-subscriptions';

@Injectable({
    providedIn: 'root'
})
export class DtfmMessageService extends MessageService {
    constructor(
        private http: HttpClient,
        protected store: Store,
        private clusterUrlProviderService: ClusterUrlProviderService,
        protected stompManager: StompManagerService
    ) {
        super('DTMF', store, stompManager);
    }

    protected getTopics(): Topic[] {
        return [Topic.MESSAGES_DTMF_NEW, Topic.MESSAGES_DTMF_EDIT, Topic.MESSAGES_DTMF_DELETE];
    }

    protected getTopicHandlers(): { [topic in Topic]?: (message: any, clusterName: string) => void } {
        return {
            [Topic.MESSAGES_DTMF_NEW]: this.newMessage.bind(this),
            [Topic.MESSAGES_DTMF_EDIT]: this.editMessage.bind(this),
            [Topic.MESSAGES_DTMF_DELETE]: this.deleteMessage.bind(this)
        };
    }

    protected effectsInitialized(): void {
        this.store.dispatch(fetchPredefinedDtmfMessages());
    }

    protected websocketInitialized(clusterName: string): void {
        this.store.dispatch(initializeDtmfMessageState({ clusterName: clusterName }));
    }

    protected deleteMessage(message: Message, clusterName: string): void {
        this.store.dispatch(deleteDtmfMessage({ message, clusterName }));
    }

    protected editMessage(message: Message, clusterName: string): void {
        this.store.dispatch(updateDtmfMessage({ message, clusterName }));
    }

    protected newMessage(message: Message, clusterName: string): void {
        this.store.dispatch(newDtmfMessage({ message, clusterName }));
    }

    public requestPredefinedDtmf() {
        return this.http.get<PreDefinedMessage[]>('assets/data/pre-defined-dtmf.json', { observe: 'body', responseType: 'json' });
    }

    public requestDtmfMessages(callId: string, clusterName: string) {
        const url = this.clusterUrlProviderService.getClusterSpecificUrl(clusterName, `${this.API_BASE_URL}${callId}/load/${this.type}`);
        return this.http.get<Message[]>(url, { observe: 'body', responseType: 'json' });
    }
}
